/* screens/sales/PlansScreen.jsx — раздел «Тарифы» консоли (/console/plans).

   Две вкладки по двум НЕЗАВИСИМЫМ правам: «Закрытые» (private_plans_access — только
   закрытые тарифы, без справочной секции публичных) и «Публичные» (public_plans_access —
   линейка B2C/B2B → тариф → сроки). У кого одно право — видит только свою вкладку,
   и переключателя нет вовсе. Вкладка — в адресе (?tab=public), чтобы ссылка коллеге
   открывала нужное; чужая вкладка по ссылке молча заменяется первой своей. */
import React from 'react';
import { PageHeader } from '../../components/patterns/PageHeader.jsx';
import { Tabs } from '../../components/patterns/Tabs.jsx';
import { Button } from '../../components/ui/Button.jsx';
import { useAuth } from '../../app/providers/AuthProvider.jsx';
import { RR } from '../../lib/router.jsx';
import { PrivatePlansPanel } from './PrivatePlansScreen.jsx';
import { PublicPlansPanel } from './PublicPlansPanel.jsx';
import { plansTabsFor, resolvePlansTab, switchPlansTab } from './plansAccess.js';

const { useSearchParams, useNavigate } = RR;

export function PlansScreen() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const tabs = plansTabsFor(user);
  const tab = resolvePlansTab(params.get('tab'), tabs);

  // Смена вкладки сбрасывает открытый тариф (?plan= у каждой вкладки свой) —
  // правило в plansAccess.switchPlansTab, рядом с остальной логикой доступа.
  const setTab = (value) => setParams((prev) => switchPlansTab(prev, value));

  return (
    <div className="section-page">
      <PageHeader
        breadcrumbs={[{ label: 'Админка', to: '/console' }, { label: 'Тарифы' }]}
        title="Тарифы"
        actions={<Button variant="ghost" iconLeft="arrow-left" onClick={() => navigate('/console')}>Сервисы</Button>}
      />
      <div className="section-body stack stack-16">
        {tabs.length > 1 && (
          <Tabs items={tabs} value={tab} onChange={setTab} ariaLabel="Вкладки раздела «Тарифы»" />
        )}
        {tab === 'private' && <PrivatePlansPanel />}
        {tab === 'public' && <PublicPlansPanel />}
      </div>
    </div>
  );
}
